/******************************************************************************
 *
 * Copyright (c) 2019-2020 ServiceActivator Inc. All Rights Reserved.
 *
 * Unauthorized copying of the code in this file, completely or partially,
 * via any medium is strictly prohibited.
 *
 * Proprietary and Confidential.
 *
 * Written by 'Vishal Goel’ <vishal@wakencode.com>, March 2020
 *
 *****************************************************************************/

import React, { Component } from "react";
import amplifyCustomUi from "aws-amplify-react-custom-ui";
import { Auth } from "aws-amplify";
import Logo from "./../../assets/logo/ServiceActivator-DarkBackground.png";
import styles from "./Loading.module.css";
import { ChasingDots } from "styled-spinkit";
import * as color from "../../shared/theme/color";

class Loading extends Component {
  /**
   * Called before rendering view first time
   * Handling logout logic
   */
  componentWillMount() {
    // checking if that view is coming from sigIn page
    let isFromSignIn = localStorage.getItem("isFromSignIn");
    // if coming from sigIn page proceed to salesforce redirect otherwise logout
    if (isFromSignIn) {
      localStorage.removeItem("isFromSignIn");
    } else {
      this.signOut();
    }
  }
  // Handle signOut and redirect to signIn page
  signOut = () => {
    Auth.signOut()
      .then(() => {})
      .catch((err) => {});
  };

  // view of loading page
  render() {
    return (
      <div className={styles.Container}>
        <div className={styles.InnerCont}>
          <img className={styles.Logo} src={Logo} alt="service activator" />
          <ChasingDots color={color.colorAccent} size={45} />
        </div>
      </div>
    );
  }
}

export default amplifyCustomUi.withAuthenticator(Loading);
